import React from 'react';
import Auxiliary from 'hoc/Auxiliary';
import { connect } from 'react-redux';
import Header from 'components/Header/Header';

const CustomHeader = (props) => {
    const { title } = props;

    return (
        <Auxiliary>
            <Header title={title} />
        </Auxiliary>
    );
};

const mapStateToProps = (state) => ({
    accountId: state.header.accountId
});

export default connect(mapStateToProps)(CustomHeader);
